// https://regex101.com/r/e0yexT/1
export const orderNumberRegex = /^\w{4}-\d{3}-(\d{8,9})$/;
